/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompetitionCustomRuleResponse
 */
export interface CompetitionCustomRuleResponse {
    /**
     * 
     * @type {string}
     * @memberof CompetitionCustomRuleResponse
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof CompetitionCustomRuleResponse
     */
    body: string;
    /**
     * 
     * @type {number}
     * @memberof CompetitionCustomRuleResponse
     */
    order?: number;
}

/**
 * Check if a given object implements the CompetitionCustomRuleResponse interface.
 */
export function instanceOfCompetitionCustomRuleResponse(value: object): value is CompetitionCustomRuleResponse {
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('body' in value) || value['body'] === undefined) return false;
    return true;
}

export function CompetitionCustomRuleResponseFromJSON(json: any): CompetitionCustomRuleResponse {
    return CompetitionCustomRuleResponseFromJSONTyped(json, false);
}

export function CompetitionCustomRuleResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompetitionCustomRuleResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'],
        'body': json['body'],
        'order': json['order'] == null ? undefined : json['order'],
    };
}

export function CompetitionCustomRuleResponseToJSON(json: any): CompetitionCustomRuleResponse {
    return CompetitionCustomRuleResponseToJSONTyped(json, false);
}

export function CompetitionCustomRuleResponseToJSONTyped(value?: CompetitionCustomRuleResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
        'body': value['body'],
        'order': value['order'],
    };
}

